/* Sticky CTA bar: reveals fixed action bars once the visitor scrolls past a
   per-bar threshold. Pinned to the top of the viewport. */
(function () {
  var bars = document.querySelectorAll('[data-sticky-cta]');
  if (!bars.length) return;

  var ticking = false;

  function update() {
    var y = window.pageYOffset;
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (isNaN(threshold)) threshold = 800;
      var show = y > threshold;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
